// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { createGroupRequested, createGroupRequestError, createGroupRequestSuccess } from './create-group.actions';

export const STATE_NAME = 'create-group';

export interface State {
  isLoading: boolean;
  isError: boolean;
}

const initialState: State = {
  isLoading: false,
  isError: false,
};

const reducer = createReducer(
  initialState,
  on(createGroupRequested, (state) => ({...state, isLoading: true, isError: false})),
  on(createGroupRequestSuccess, (state) => ({...state, isLoading: false})),
  on(createGroupRequestError, (state) => ({...state, isLoading: false, isError: true})),
);

export function createGroupReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

